import { call, put } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import makeRequest from '../../../utils/makeRequest';
import { OK } from '../../../configs/serverStatusCodes';
import { loadHostProblemsFailed, loadHostProblemsSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import processError from '../../../utils/processError';

export default function* loadHostProblems(action) {
  try {
    const url = `${BACKEND_URL}/host-problems/${action.payload}/current`;
    const pool = {};
    const userDataResponse = yield makeRequest(url, pool, action, 'POST');
    const responseJson = yield userDataResponse.json();
    if (userDataResponse && userDataResponse.status === OK && responseJson.result) {
      yield put(loadHostProblemsSuccessful(responseJson.result));
      yield call(resolveActionPromise(action, responseJson.result));
    } else {
      yield put(loadHostProblemsFailed(responseJson));
      yield call(rejectActionPromise(action, responseJson));
    }
  } catch (e) {
    yield put(loadHostProblemsFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
